import { Component } from '@angular/core';
import { AdminAddSupplierComponent } from '../../../../components/admin-dashboard-component/admin-suppliers-component/admin-add-supplier-component/admin-add-supplier-component';

@Component({
  selector: 'app-admin-add-supplier',
  imports: [AdminAddSupplierComponent],
  templateUrl: './admin-add-supplier.html',
  styleUrl: './admin-add-supplier.scss',
})
export class AdminAddSupplier {}
